var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var _require = require('ipfs-unixfs-importer'),
    importer = _require.importer;

var block = {
  get: function () {
    var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cid) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              throw new Error("unexpected block API get for ".concat(cid));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function get(_x) {
      return _get.apply(this, arguments);
    }

    return get;
  }(),
  put: function () {
    var _put = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              throw new Error('unexpected block API put');

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function put() {
      return _put.apply(this, arguments);
    }

    return put;
  }()
};

exports.of = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(content, options) {
    var lastCid, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, cid;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            options = options || {};
            options.onlyHash = true;

            if (typeof content === 'string') {
              content = new TextEncoder().encode(content);
            }

            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context3.prev = 5;
            _iterator = _asyncIterator(importer([{
              content: content
            }], block, options));

          case 7:
            _context3.next = 9;
            return _iterator.next();

          case 9:
            if (!(_iteratorAbruptCompletion = !(_step = _context3.sent).done)) {
              _context3.next = 15;
              break;
            }

            cid = _step.value.cid;
            lastCid = cid;

          case 12:
            _iteratorAbruptCompletion = false;
            _context3.next = 7;
            break;

          case 15:
            _context3.next = 21;
            break;

          case 17:
            _context3.prev = 17;
            _context3.t0 = _context3["catch"](5);
            _didIteratorError = true;
            _iteratorError = _context3.t0;

          case 21:
            _context3.prev = 21;
            _context3.prev = 22;

            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context3.next = 26;
              break;
            }

            _context3.next = 26;
            return _iterator.return();

          case 26:
            _context3.prev = 26;

            if (!_didIteratorError) {
              _context3.next = 29;
              break;
            }

            throw _iteratorError;

          case 29:
            return _context3.finish(26);

          case 30:
            return _context3.finish(21);

          case 31:
            return _context3.abrupt("return", "".concat(lastCid));

          case 32:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[5, 17, 21, 31], [22,, 26, 30]]);
  }));

  return function (_x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();